import is from '@sindresorhus/is';

import type { UrlTileDefinition, UrlTilePayload } from './types';
import { URL_TILE_SEARCH_PARAM } from './types';

export const findUrlTileDefinition = (
    payload: UrlTilePayload,
    definitions: readonly UrlTileDefinition[],
): UrlTileDefinition | undefined => {
    return definitions.find((definition) => definition.type === payload.type);
};

export const serializeUrlTilePayloads = (
    payloads: readonly UrlTilePayload[],
    definitions: readonly UrlTileDefinition[],
): readonly string[] => {
    return payloads
        .map((payload) => findUrlTileDefinition(payload, definitions)?.serializePayload(payload))
        .filter(is.string);
};

export const writeUrlTileSearchParams = ({
    definitions,
    payloads,
    searchParams,
}: {
    readonly definitions: readonly UrlTileDefinition[];
    readonly payloads: readonly UrlTilePayload[];
    readonly searchParams: URLSearchParams;
}): URLSearchParams => {
    const nextParams = new URLSearchParams(searchParams);

    nextParams.delete(URL_TILE_SEARCH_PARAM);

    for (const value of serializeUrlTilePayloads(payloads, definitions)) {
        nextParams.append(URL_TILE_SEARCH_PARAM, value);
    }

    return nextParams;
};
